import type { BreakpointNames } from '@workramp/ui';
import type { CSSProperties } from 'react';
import styled, { css } from 'styled-components';
import { IconButton, Row, pxToRem } from '@workramp/ui';
import { DEVELOPMENT_CONTENT_CARD_HEIGHT } from '~/elc/features/content-cards';

const breakpointNames = ['xs', 'sm', 'md', 'lg', 'xl'] as const;

export const CarouselWrapper = styled.div<{ $isCentered?: boolean; $width?: CSSProperties['width'] }>`
  width: ${({ $width = '100%' }) => $width};
  overflow-x: hidden;

  ${({ theme, $isCentered }) =>
    $isCentered &&
    breakpointNames.map((breakpointName) => {
      const name = breakpointName as BreakpointNames;
      const query = theme.breakpoints.up(name);
      const containerPadding = theme.layout.containerPadding[name];

      return css`
        @media ${query} {
          margin: 0 -${pxToRem(theme.spacing(containerPadding))}rem;
          padding: 0 ${pxToRem(theme.spacing(containerPadding))}rem;
        }
      `;
    })}
`;

export const CarouselRow = styled(Row)`
  flex-wrap: nowrap;
  align-items: center;
  padding-bottom: 20px;
`;

export const PaginationWrapper = styled.div`
  width: 100%;
`;
export const CarouselItemWrapper = styled.div<{ $height?: CSSProperties['height']; $isCentered?: boolean }>`
  scroll-margin: ${({ theme }) => theme.spacing(2)}px;
  height: ${({ $height }) => $height || `${DEVELOPMENT_CONTENT_CARD_HEIGHT}px`};

  ${({ theme, $isCentered }) =>
    $isCentered &&
    breakpointNames.map((breakpointName) => {
      const name = breakpointName as BreakpointNames;
      const query = theme.breakpoints.up(name);
      const containerPadding = theme.layout.containerPadding[name];

      return css`
        @media ${query} {
          scroll-margin: ${pxToRem(theme.spacing(containerPadding))}rem;
        }
      `;
    })}
`;

const BaseArrowButtonStyles = css`
  box-shadow: ${({ theme }) => theme.shadows[100]};
  position: absolute;
  top: ${({ theme }) => theme.spacing(25)}px;
  transform: translateY(-50%);
  z-index: 3;
`;

export const StyledIconRightButton = styled(IconButton)`
  ${BaseArrowButtonStyles}
  right: -${({ theme }) => theme.spacing(3)}px;
`;

export const StyledIconLeftButton = styled(IconButton)`
  ${BaseArrowButtonStyles}
  left: -${({ theme }) => theme.spacing(3)}px;
`;
